<template>
  <div class="gaode" ref="container" id="container"></div>
</template>

<script>
import gaodeUtils from '@/utils/gaodeUtils'
export default {
  name: 'CGaode',
  props: {
    mapData: {
      type: Object,
      default: () => ({
        viewMode: '2D', //是否为3D地图模式
        zoom: 10, //初始化地图级别
        center: [105.602725, 37.076636], //初始化地图中心点位置
      }),
    },
  },
  components: {},
  data() {
    return {
      map: null,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.initMap()
  },
  destroyed() {
    console.log('地图销毁')
    this.map && this.map.destroy()
    this.map = null
    gaodeUtils.setMap(null)
  },
  methods: {
    initMap() {
      this.map = new AMap.Map(this.$refs.container, {
        ...this.mapData,
        resizeEnable: true, //是否监控地图容器尺寸变化
        scrollWheel: true,
      })
      gaodeUtils.setMap(this.map)
      gaodeUtils.setAMap(AMap)
      this.$emit('mapLoaded')
    },
  },
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.gaode {
  width: 100%;
  height: 100%;
}
::v-deep .amap-logo {
  display: none;
  opacity: 0 !important;
}
::v-deep .amap-copyright {
  opacity: 0;
}
</style>
